module.exports = __webpack_public_path__ + "img/list.fa1da574.png";